
import { actions } from "@gsd/redux-store-backoffice";
import React from "react";
import autobind from "react-autobind";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Users from "../component/Users/Users";

const {
  idmBackOffice: {
    creators: {
      getApplications,
      getRoles,
      getAcls,
      getUsers,
      addUser,
      updateUser,
      addUserAppRoleAcl,
      getUserById,
      getApplicationAcls,
      removeUserAppRole,
      searchUser,
      deleteUser
    }
  }
} = actions;

const mapStateToProps = (state: { idmBackOffice: any; }) => ({
  ...state.idmBackOffice
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getApplications: async() => dispatch(await getApplications()),
    getRoles: async() => dispatch(await getRoles()),
    getAcls: async() => dispatch(await getAcls()),
    getUsers: async () => dispatch(await getUsers()),
    addUser: (obj: unknown) => dispatch(addUser(obj)),
    updateUser: (id:number,obj: any) => dispatch(updateUser(obj, { id })),
    deleteUser: async (userId:number) => dispatch(deleteUser(null, { userId : userId })),
    getUserById: (userId:number) => dispatch(getUserById(null, { userId : userId })),
    setUserAppRoleAcl: (obj: unknown) => dispatch(addUserAppRoleAcl(obj)),
    getApplicationAcls: async (appUid: any) => dispatch(await getApplicationAcls(null, { appUid: appUid })),
    // removeUserAppRole: async(userId: number, applicationId: number , roleId: number ) => dispatch(await removeUserAppRole(null, { userId, applicationId, roleId })),
    removeUserAppRole: async(userAppRole: unknown) => dispatch(await removeUserAppRole(null, userAppRole)),
    getInitOptions : async () => {
      await Promise.all([
        dispatch(await getApplications()),
        dispatch(await getRoles()),
        dispatch(await getAcls()),
      ]);
    },
    searchUser: async (query: unknown) => dispatch(await searchUser(query)),
  };
};

type ApplicationContainerProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class ApplicationContainer extends React.Component<ApplicationContainerProps> {
  constructor(props: ApplicationContainerProps) {
    super(props);
    autobind(this);
  }

  async componentDidMount() {
    await this.props.searchUser();
  }

  _addUser = async (obj: unknown, query: unknown) => {
    await this.props.addUser(obj);
    await this.props.searchUser(query);
  };

  _updateUser = async (obj: { id: any; }, query: unknown) => {
    await this.props.updateUser(obj.id, { ...obj });
    await this.props.searchUser(query);
  };

  _deleteUser = async (obj: { uid: any; }, query: unknown) => {
    await this.props.deleteUser(obj.uid);
    await this.props.searchUser(query);
  };

  _setApplicationUserRoleAcl = async (values: { userId: any; }) => {
    await this.props.setUserAppRoleAcl(values);
    await this.props.getUserById(values.userId);
    return (this.props.user);
  };
  _searchData = async (query: unknown) => {
    await this.props.searchUser(query);
  };

  _getAppAcl = async (appUid: any) => {
    await this.props.getApplicationAcls(appUid);
    return this.props.appAcls;
  };

  _getInitOptions = async() => {
    await this.props.getInitOptions();
    return ({
      applications: this.props.applications,
      roles : this.props.roles,
      acls : this.props.acls
    });
  };

  _handleDeleteUserAppRole = async(userAppRole: { userId: any; }) => {
    await this.props.removeUserAppRole(userAppRole);
    await this.props.getUserById(userAppRole.userId);
    return (this.props.user);
  };

  render() {
    const { users } = this.props;
    return (
      <Users
        tableData={users}
        getOptions={this._getInitOptions}
        getAppAcls={this._getAppAcl}
        createEntity={this._addUser}
        deleteEntity={this._deleteUser}
        editEntity={this._updateUser}
        searchData={this._searchData}
        setUserAppRoleAcl={this._setApplicationUserRoleAcl}
        deleteUserAppRole={this._handleDeleteUserAppRole}
      />
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationContainer);
